import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    Validators,
} from '@angular/forms';
import {
    ICommentChangeEvent,
    ICommentEditEvent,
} from '@components/ui-comment/ui-comment.model';
import { IComment } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@services';
import UiValidators, { UI_COMMENT_MAX_LENGTH } from '@validators';

@Component({
    selector: 'ui-comment',
    templateUrl: 'ui-comment.component.html',
    styleUrls: ['ui-comment.component.scss'],
    providers: [FormBuilder],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCommentComponent {

    @Input() public set model(value: IComment) {
        this.original = value;
        this.current = Object.assign(this.current, this.original);
        this.form.get('text')!.setValue(this.current.text);
    }

    @Input() public editPermission?: string;
    @Input() public disable?: boolean;

    @Output() public edited = new EventEmitter<ICommentEditEvent>();
    @Output() public updated = new EventEmitter<ICommentChangeEvent>();
    @Output() public deleted = new EventEmitter<ICommentChangeEvent>();

    public form: FormGroup;
    public editing = false;
    public saving = false;

    public original?: IComment;
    public current: IComment = <IComment>{};

    constructor(
        fb: FormBuilder,
        private _modalService: ModalService,
        private _translateService: TranslateService,
    ) {

        this.form = fb.group({
            'text': [this.original && this.original.text, Validators.compose([
                UiValidators.required(),
                Validators.maxLength(UI_COMMENT_MAX_LENGTH)],
            )],
        });
    }

    get dirty(): boolean {
        return this.form.get('text')!.value !== this.original!.text;
    }

    edit() {
        this.edited.emit({
            comment: this.original,
            continue: () => {
                this.current = Object.assign(this.current, this.original);
                this.form.get('text')!.setValue(this.current.text);
                this.editing = true;
            },
        } as ICommentEditEvent);
    }

    delete() {
        this._modalService.onConfirm(null,
            () => this.deleted.emit({
                comment: this.original,
                success: () => { },
                error: () => { },
            } as ICommentChangeEvent),
            () => { },
            this._translateService.instant('comments_delete_comment_warning'));
    }

    save() {
        if (!this.form.valid) {
            return;
        }
        this.current.text = this.form.get('text')!.value;
        this.saving = true;
        this.updated.emit({
            comment: this.current,
            success: () => {
                this.original = Object.assign(this.original, this.current);
                this.saving = false;
                this.editing = false;
                this.form.reset(this.form.value);
            },
            error: () => this.saving = false,
        });
    }

    cancel() {
        this.current = Object.assign(this.current, this.original);
        this.form.get('text')!.setValue(this.current.text);
        this.editing = false;
    }
}
